import { createTheme, lighten, darken } from '@mui/material/styles';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1b2a41',
      dark: '#111d2f',
      light: '#324a69',
    },
    secondary: {
      main: '#2e3f5b',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#1b2a41',
      secondary: '#324a69',
    },
    error: {
      main: '#f87171',
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#bbb0ff',
    },
    secondary: {
      main: '#a3a3a3',
    },
    background: {
      default: '#131415',
      paper: '#1c1d1f',
    },
    text: {
      primary: '#e8ecef',
      secondary: '#e8ecef',
    },
    error: {
      main: '#ff6b6b',
    },
  },
});

// Build a theme from any user-picked accent color. The chosen color drives
// `primary` + `secondary`; light/dark mode picks the base canvas colors. Used
// by the "Accent color" picker in ThemeContext.js — useful for previewing
// brand-color experiments without committing to a full re-skin.
export const makeAccentTheme = (accent, mode = 'light') => {
  const base = mode === 'dark'
    ? {
        background: { default: '#131415', paper: '#1c1d1f' },
        text: { primary: '#e8ecef', secondary: '#e8ecef' },
        errorMain: '#ff6b6b',
      }
    : {
        background: { default: '#ffffff', paper: '#ffffff' },
        text: { primary: '#1b2a41', secondary: '#324a69' },
        errorMain: '#f87171',
      };

  return createTheme({
    palette: {
      mode,
      primary: {
        main: accent,
        light: lighten(accent, 0.3),
        dark: darken(accent, 0.3),
      },
      secondary: {
        main: accent,
      },
      background: base.background,
      text: base.text,
      error: { main: base.errorMain },
    },
  });
};
